/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Displaying_PageInputs */



/**
* | output |
* | --- |
* | "Something went wrong while displaying the page. Click \"Reload page\" below to try again. If the problem persists, contact support@cruitive.com." |
*
* @param {Error_Displaying_PageInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const error_displaying_page = /** @type {((inputs?: Error_Displaying_PageInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Displaying_PageInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Something went wrong while displaying the page. Click \"Reload page\" below to try again. If the problem persists, contact support@cruitive.com.")
	return /** @type {LocalizedString} */ ("Någonting har gått fel när sidan skulle visas. Klicka på \"Ladda om sidan\" nedan för att försöka igen. Om felet kvarstår kan du kontakta support@cruitive.com.")
});